export const DeviceListTableHeader = {
  columns: {
    id: {
      title: 'ID датчика',
      filter: true
    },
    eui: {
      title: 'Серийный номер',
      filter: true
    },
    lastTime: {
      title: 'Дата последнего выхода на связь',
      filter: true
    }
  },
  actions: {
    add:    false,
    edit:   false,
    delete: false
  },
  pager: {
    perPage: 10
  }
};



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/models/DeviceListTableHeader.ts